<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_enrollments'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="text-center mt-4" v-if="schoolterm != ''">
                <h3>{{ schoolterm.name }} {{ year }}</h3>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        v-show="u"
                        @click="edit(data.item.id, data.item.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  enrollmentMethods,
  enrollmentComputed,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Enrollments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Enrollments",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Enrollments", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "class", label: "Class", visible: true },
        { key: "male", label: "Males", visible: true },
        { key: "female", label: "Females", visible: true },
        { key: "boarding", label: "Boarding", visible: true },
        { key: "day", label: "Day", visible: true },
        { key: "total", label: "Total", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      name: "",
      schoolterm: "",
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...enrollmentComputed,
    ...schooltermComputed,
    List() {
      return this.enrollments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.enrollments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.enrollments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchEnrollments();
    this.fetchSchoolTerms();
    this.TotalRows = this.enrollments.length;
    this.isBusy = false;
    // this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...enrollmentMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      this.filterEnrollments({
        schoolterm: this.schoolterm.id,
        year: this.year,
      });
    },
  },
};
</script>
